import { VForm } from "vuetify/components";
import { snackbarInjectionKey } from "~/assets/injection-keys";

interface SubmitOptions {
  skipValidation?: boolean;
  activeValidation?: boolean;
  onInvalid?: () => void;
  successMsg?: string;
}

export default function useForm() {
  const snackbar = inject(snackbarInjectionKey)!;
  const formRef = ref<VForm>();
  const valid = computed(() => formRef.value?.isValid);
  const loading = ref(false);
  const submitted = ref(false);

  return {
    valid,
    loading,
    submitted,

    setFormRef(e: any) {
      formRef.value = e;
    },

    ready: computed(() => !!formRef.value),

    invalidItems: computed(() => formRef.value?.items.filter(item => !item.isValid) || []),

    async submit(submitFn: () => void | Promise<void>, options: SubmitOptions = {}) {
      const { skipValidation, activeValidation, onInvalid, successMsg } = options;
      if (!skipValidation) {
        const valid = await isValid(activeValidation);
        if (!valid) return onInvalid?.();
      }
      loading.value = true;
      try {
        await submitFn();
        submitted.value = true;
      } catch (e) {
        const msg = typeof e == 'string' ? e : (e as Error).message;
        return snackbar.value!.showError(msg);
      } finally {
        loading.value = false;
      }
      if (successMsg) {
        snackbar.value!.showSuccess(successMsg);
      }
    },

    reset() {
      formRef.value!.reset();
    },

    resetValidation() {
      formRef.value!.resetValidation();
    }
  };

  async function isValid(active = false) {
    if (!formRef.value) return false;
    if (!active) return valid.value;
    const validation = await formRef.value.validate();
    return validation.valid;
  }
}